import { render, staticRenderFns } from "./Hyrum.vue?vue&type=template&id=2d153c12&scoped=true&"
import script from "./Hyrum.vue?vue&type=script&lang=js&"
export * from "./Hyrum.vue?vue&type=script&lang=js&"
import style0 from "./Hyrum.vue?vue&type=style&index=0&id=2d153c12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d153c12",
  null
  
)

export default component.exports